export default "__VITE_ASSET__DtFpFsFJ__"